export default "__VITE_ASSET__DRzhtlf4__"